import { type FC, type PropsWithChildren } from 'react';
import { Box, type BoxProps } from '@mui/material';

export type CenteredLayoutProps = PropsWithChildren<
  BoxProps & {
    /**
     * Whether to center the content vertically.
     */
    vertical?: boolean;

    /**
     * Whether to center the content horizontally.
     */
    horizontal?: boolean;
  }
>;

export const CenteredLayout: FC<CenteredLayoutProps> = ({
  children,

  vertical,
  horizontal,

  ...props
}) => (
  <Box
    sx={{
      display: 'flex',
      flexGrow: 1,
      justifyContent: horizontal ? 'center' : undefined,
      alignItems: vertical ? 'center' : undefined,
    }}
    {...props}>
    {children}
  </Box>
);
